var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"duration-dropdown"},[_c('div',{staticClass:"duration-dropdown__label"},[_vm._v("Liczba dni")]),_vm._v(" "),_c('div',{staticClass:"duration-dropdown__close"},[_c('span',{staticClass:"custom-icon--cross calendar-header__icon",on:{"click":_vm.close}})]),_vm._v(" "),_c('RadioList',{staticClass:"duration-dropdown__body",attrs:{"value":_vm.value.range,"options":_vm.value.ranges},on:{"input":_vm.input}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb771dd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/fields/DurationDropdown.vue
// module id = 805
// module chunks = 1